import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'modules/app/services/loader.service';
import { AuthService } from '../../../app/services/auth.service';
import { ApiGatewayHelperService } from 'modules/app/services/apigateway-helper.service';
import { XAPIDataGenerator } from 'libs-frontend-xapi/dist/js/xapidatagenerator.js';
import { XAPIAnalytics } from 'libs-frontend-xapi/dist/js/xapianalytics.js';
import { AppHelperService } from 'modules/app/services/app-helper.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { LTILaunchService } from '../../services/lti-launch.service';
import { TestHelperService } from '../../../shared-postlogin/services/test-helper.service';
import { UserAttemptHelper } from 'modules/shared-postlogin/services/user-attempt-helper.service';


@Component({
    selector: 'submit-lti-test',
    templateUrl: './submit-lti-test.template.html',
    styleUrls: ['./submit-lti-test.style.scss'],
    standalone: false
})

export class SubmitLtiTest implements OnInit {
    spaceId: string;
    private bundleCode: string;
    productCode: string;
    itemId: string;
    xapiLOAnalytics: any;
    isTestSubmitted: boolean;
    ltiLog: string;
    classId: string;
    assignmentId: string;
    role: string;
    attempt: any;
    attemptsLeft: any;
    pageSource: string;
    learnerId: string;
    launchMode: string;
    testTypeTag : string;
    extLinkStatementId : string;
    private contributesToCompletionFlag: boolean;
    accessibleUnitCode: string;
    accessibleActivityId: string;
    ltik: string;
    cid: string;
    ltiGiId : string;
    rcode : string;

    constructor(
        private router: Router,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private authService: AuthService,
        private route: ActivatedRoute,
        private ltiLaunchService: LTILaunchService,
        private appHelperService: AppHelperService,
        private loaderService: LoaderService,
        public testHelperService: TestHelperService,
        private userAttemptHelperService : UserAttemptHelper
    ) { }
    ngOnInit() {
        this.loaderService.showLoader();
        let ltiParamsKey = this.route.snapshot.params.ltiParamsKey;
        let itemParams = this.ltiLaunchService.getDataFromLocalStorage(ltiParamsKey)
        this.ltiLog = this.route.snapshot.queryParams['lti_log'] && this.route.snapshot.queryParams['lti_log'].toLowerCase();

        if (itemParams) {
            this.spaceId = itemParams.spaceId;
            this.bundleCode = itemParams.bundleCode;
            this.productCode = itemParams.productCode;
            this.itemId = itemParams.itemCode;
            this.classId = itemParams.classId;
            this.assignmentId = itemParams.assignmentId;
            this.attempt = itemParams.attempt;
            this.attemptsLeft = itemParams.attemptsLeft;
            this.pageSource = itemParams.pageSource;
            this.learnerId = itemParams.learnerId;
            this.launchMode = itemParams.launchMode;
            this.testTypeTag = itemParams.testTypeTag
            this.contributesToCompletionFlag = itemParams.contributesToCompletionFlag;
			this.accessibleUnitCode = itemParams.accessibleUnitCode;
            this.accessibleActivityId = itemParams.accessibleActivityId;
            this.extLinkStatementId = itemParams.extLinkStatementId;
            this.ltik = itemParams.ltik;
            this.cid = itemParams.cid;
            this.ltiGiId = itemParams.ltiGiId;
            this.rcode = itemParams.rcode;
            this.apiGatewayHelperService.setSpaceId(itemParams.spaceId);

            if(this.testHelperService.isValidTestType(this.testTypeTag)){
                this.generateAndPostStatements().then(()=>{
                    this.navigateUser();
                })
            } else {
                this.appHelperService.navigateToDashboardApp([], { forceExit: true });
            }  
        }
        else {
            this.appHelperService.navigateToDashboardApp([], { forceExit: true });
        }

    }

    async generateAndPostStatements() {
        if (this.launchMode === 'review' || !(this.pageSource === 'LEARNER_ATTEMPT_ASSIGNMENT' || this.pageSource === 'LEARNER_LAUNCH_FROM_DASHBOARD' || this.pageSource === 'LEARNER_REVIEW_TEST' || this.pageSource === 'LEARNER_CEFR_REVIEW_TEST')) {
            return;
        }
        const userData = this.authService.getUserData();
        let routePrefix = this.apiGatewayHelperService.getApiGatewayPrefixUrl();
        var serverRoutePrefix = routePrefix.substr(0, routePrefix.length - 1);
        this.xapiLOAnalytics = new XAPIAnalytics({
            serverRoutePrefix: serverRoutePrefix,
            productCode: this.productCode,
            spaceId: this.spaceId,
            classId: this.classId,
            userDetails: { extUserId: userData.extUserId }
        });
        let attemptObject;
        if(this.attempt.id && this.attempt.activityId){
             attemptObject = {
                id : this.attempt.id,
                activity_id: this.attempt.activityId
            }
        }
        if (this.ltiLog && this.ltiLog === 'submitted') {
            let options = {
                'submission_order': this.attempt.number,
                meta: {
                    contributesToCompletion: this.contributesToCompletionFlag,
                },
                ...(this.extLinkStatementId && { 'ext_link_id': this.extLinkStatementId }),
                ...(this.ltiGiId && {ltiPlatform : {ltiGradebookItemId : this.ltiGiId}})
            }
            if(attemptObject){
                options['attempt'] = attemptObject
            }
            let submittedStatement = XAPIDataGenerator.generateCustomStatement(this.itemId, 'submitted_external', options)
            await Promise.all([
                this.xapiLOAnalytics.postStatementsNoBatch(submittedStatement),
                this.userAttemptHelperService.endUserAttempt(this.productCode, this.itemId, this.attempt.id).toPromise()
            ]);
        }
        const statementOptions: any = {
            meta: {
                contributesToCompletion: this.contributesToCompletionFlag,
            },
            ...(this.ltiGiId && { ltiPlatform: { ltiGradebookItemId: this.ltiGiId } })
        };
        if(attemptObject){
            statementOptions.attempt = attemptObject;
        }
        let closedStatement = XAPIDataGenerator.generateCustomStatement(this.itemId, 'closed', statementOptions)       
        return await this.xapiLOAnalytics.postStatementsNoBatch(closedStatement);
    }

    navigateUser() {
        /**
         * Learner from Attempt assignment: If test is submitted then redirects to class assignment page
         *                                  If test is closed then redirets to OLP view assignment page
         */
        switch (this.pageSource) {
            case 'TEACHER_CREATE_ASSIGNMENT': // Navigate to OLP view assignment page 
                if (this.ltik ) {
                    const urlOptions = {
                        queryParams: {
                            "ltik": this.ltik
                        }
                    };
                    this.router.navigate(['/teacher', this.spaceId, 'class', this.classId, 'ltideeplinking','product', this.productCode, 'item', this.itemId], urlOptions);
                    break;
                }
                this.router.navigate(['/teacher', this.spaceId, 'class', this.classId, 'assignments', 'product', this.productCode, 'item', this.itemId]);
                break;
            case 'TEACHER_VIEW_ASSIGNMENT': // Navigate to OLP view assignment page 
                this.router.navigate(['/teacher',  this.spaceId, 'class', this.classId, 'product', this.productCode, 'assignment', this.assignmentId, 'item', this.itemId]);
                break;    
            case 'TEACHER_PREVIEW_MATERIALS': 
                // Navigate to the activity itself if launched from LTI
                if(this.accessibleUnitCode && this.accessibleActivityId) {
                    this.router.navigate(['/teacher', this.spaceId, 'class', this.classId, 'product', this.productCode, 'unit', this.accessibleUnitCode, 'activity', this.accessibleActivityId, 'item', this.itemId]);
                    break;
                }
                // Navigate to preview assignment page 
                this.router.navigate(['/teacher', this.spaceId, 'class', this.classId, 'product', this.productCode, 'item', this.itemId]);
                break;    
            case 'LEARNER_ATTEMPT_ASSIGNMENT':
                if (this.ltiLog === 'submitted'){ // Navigates to class assignment page
                    const urlOptions = {
                        queryParams: {
                            "lti_return_status": "submitted",
                            ...(this.attemptsLeft && { 'attempts-left': this.attemptsLeft - 1 })
                        }
                    };
                    this.router.navigate(['/learner', this.spaceId, 'class', this.classId, 'product', this.productCode, 'assignment', this.assignmentId, 'item', this.itemId], urlOptions);
                }
                else {  // Navigate to OLP view assignment page 
                    this.router.navigate(['/learner', this.spaceId, 'class', this.classId, 'product', this.productCode, 'assignment', this.assignmentId, 'item', this.itemId]);
                }
                break;
            case 'TEACHER_REVIEW_TEST':
                let options = {
                    hashParams: {
                        aid: this.assignmentId,
                        sid: this.learnerId
                    },
                    forceExit: true
                }
                this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'view', 'assignments'], options);
                break;
            case 'LEARNER_REVIEW_TEST': {
                if (this.launchMode === 'review') {
                    const options = {
                        hashParams: {
                            aid: this.assignmentId
                        },
                        forceExit: true
                    }
                    this.appHelperService.navigateToClassApp(['learner', this.spaceId, 'class', this.classId, 'assignments'], options);
                }
                else { //  launchMode is not review, considering it as attempt launch mode
                    if (this.ltiLog === 'submitted') { // Navigates to class assignment page
                        const urlOptions = {
                            queryParams: {
                                "lti_return_status": "submitted",
                                ...(this.attemptsLeft && { 'attempts-left': this.attemptsLeft - 1 })
                            }
                        };
                        this.router.navigate(['/learner', this.spaceId, 'class', this.classId, 'product', this.productCode, 'review-assignment', this.assignmentId, 'item', this.itemId], urlOptions);
                    }
                    else {  // Navigate to OLP view assignment page 
                        this.router.navigate(['/learner', this.spaceId, 'class', this.classId, 'product', this.productCode, 'review-assignment', this.assignmentId, 'item', this.itemId]);
                    }
                }
                break;
            }
            case 'TEACHER_PREVIEW_LIBRARY':
                if (this.ltik && this.cid) {
                    const urlOptions = {
                        queryParams: {
                            "lf": "ltd",
                            "cid": this.cid,
                            "ltik": this.ltik
                        }
                    };
                    this.router.navigate(['/teacher',  this.spaceId, 'product', this.productCode, 'item', this.itemId], urlOptions);
                    break;
                }
                this.router.navigate(['/teacher',  this.spaceId, 'product', this.productCode, 'item', this.itemId]);
                break;
            case 'LEARNER_LAUNCH_FROM_DASHBOARD': {
                // Navigate to the activity itself if launched from LTI
                if(this.accessibleUnitCode && this.accessibleActivityId) {
                    const urlOptions = {
                        queryParams: {
                            ...(this.ltiGiId && { 'ltiGiId': this.ltiGiId }),
                            ...(this.ltik && { 'ltik': this.ltik }),
                            ...(this.rcode && { 'rcode': this.rcode })
                        }
                    };
                    this.router.navigate(['/learner', this.spaceId, 'product', this.productCode, 'class', this.classId, 'unit', this.accessibleUnitCode, 'activity', this.accessibleActivityId, 'item', this.itemId], urlOptions);
                    break;
                }
                if (this.ltiLog === 'submitted') {
                    this.generateBannerData();
                    const urlOptions = {
                        queryParams: {
                            showMessageBanner: true
                        },
                        forceExit: true
                    }
                    this.appHelperService.navigateToDashboardApp(['learner', 'dashboard'], urlOptions);
                }
                else if (this.classId) {
                    this.router.navigate(['/learner', this.spaceId, 'product', this.productCode, 'class', this.classId, 'item', this.itemId]);
                }
                else {
                    this.router.navigate(['/learner', this.spaceId, 'product', this.productCode, 'item', this.itemId]);
                }             
                             
                break;
            }
            case 'TEACHER_CEFR_REVIEW_TEST': {
                const urlOptions = {
                    hashParams: {
                        elem : 'cefr-review'
                    },
                    forceExit: true
                }
                const folderCode = this.appHelperService.getLastFolderCodeFromItemId(this.itemId);
                this.appHelperService.navigateToClassApp(['teacher', this.spaceId, 'class', this.classId, 'learner', this.learnerId,
                    'bundle', this.bundleCode, 'cefr-report', 'product', this.productCode, encodeURIComponent(folderCode)], urlOptions);
                break;
            }
            case 'LEARNER_CEFR_REVIEW_TEST': {
                const urlOptions = {
                    hashParams: {
                        elem: 'cefr-review'
                    },
                    forceExit: true
                }
                const folderCode = this.appHelperService.getLastFolderCodeFromItemId(this.itemId);
                this.appHelperService.navigateToClassApp(['learner', this.spaceId, 'class', this.classId, 'bundle', this.bundleCode,
                    'cefr-report', 'product', this.productCode, encodeURIComponent(folderCode)], urlOptions);
                break;
            }
            default:
                this.appHelperService.navigateToDashboardApp([], { forceExit: true });
                break;
        }
    }

    // Function to create and set banner data in local storage.
    generateBannerData() {
        const bannerMetaData = {
            langFileKey: 'LEARNER.DASHBOARD.TEST_SUBMISSION_MESSAGE',
            config: { iconClass: 'nemo-font nemo-info' }
        }
        this.appHelperService.setBannerDataInLocalStorage(bannerMetaData, this.authService.getUserData().extUserId);
    }
}